import { render, staticRenderFns } from "./SpinnerComponent.vue?vue&type=template&id=222e6d5e&scoped=true&"
import script from "./SpinnerComponent.vue?vue&type=script&lang=js&"
export * from "./SpinnerComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerComponent.vue?vue&type=style&index=0&id=222e6d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222e6d5e",
  null
  
)

export default component.exports